import { render, staticRenderFns } from "./EventTicketGroups.vue?vue&type=template&id=fee915ea&scoped=true&"
import script from "./EventTicketGroups.vue?vue&type=script&lang=js&"
export * from "./EventTicketGroups.vue?vue&type=script&lang=js&"
import style0 from "./EventTicketGroups.vue?vue&type=style&index=0&id=fee915ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee915ea",
  null
  
)

export default component.exports